import enUsTranslations from './en-us'
import frFrTranslations from './fr-fr'

export default {
  'en-US': enUsTranslations,
  'fr-FR': frFrTranslations,
}
